"use strict";

import { Application } from "../../main/application.js";
import { EventListener } from "../secondary/eventListener.js";
import { defaultScreenSizeConfig } from "../../defaultConfigs/defaultScreenSizeConfig.js";

export class Screen {
    static _main;
    static get main() { return Screen._main; }
    static get UI() { return Screen._main.ui; }

    constructor(screenSizeConfig) {
        this.screenSizeConfig = screenSizeConfig ?? defaultScreenSizeConfig;

        this.size = {
            width: 0,
            height: 0,
            center: { x: 0, y: 0 },
            ratio: 0,
            bounds: { width: 0, height: 0 }
        };

        this.stageScale = 1;
        
        this._prevSize = { width: 0, height: 0 };
        this._prevOrientation = "landscape";

        this.ui = { scaleFactor: this.platformConfig.scaleFactor };

        this.resolutionListener = new EventListener("onResolutionChanged");
        this.orientationListener = new EventListener("onOrientationChanged");

        Application.main.stage.scale.set(1);

        Application.main.ticker.add(() => this._update());

        this._update();
    }

    get platformConfig() {
        return Application.main.device.isDesktop ? this.screenSizeConfig.desktop :
            this.orientation == "landscape" ? this.screenSizeConfig.mobile.landscape :
            this.screenSizeConfig.mobile.portrait; 
    }

    _update() {
        this.size.width = document.documentElement.clientWidth;
        this.size.height = document.documentElement.clientHeight;
        this.size.center.x = this.size.width / 2;
        this.size.center.y = this.size.height / 2;
        this.size.ratio = this.size.width / this.size.height;
        this.orientation = Screen.getOrientation(this.size.ratio);

        if (this._prevSize.width != this.size.width ||
            this._prevSize.height != this.size.height) {
            this._prevSize.width = this.size.width;
            this._prevSize.height = this.size.height;

            Application.main.view.style.width = this._prevSize.width + "px";
            Application.main.view.style.height = this._prevSize.height + "px";

            Application.main.renderer.resize(this._prevSize.width, this._prevSize.height);

            this.platformSize = this.platformConfig;

            this.stageScale = Math.min(
                this._prevSize.width / this.platformSize.safe.width,
                this._prevSize.height / this.platformSize.safe.height
            );

            this.size.bounds.width = this.size.width;
            this.size.bounds.height = this.size.height;

            // Application.main.stage.scale.set(this.stageScale);
            Application.main.stage.position.set(this.size.center.x, this.size.center.y);
            
            Application.main.render();

            this.resolutionListener.dispatch();

            if (this._prevOrientation != this.orientation) {
                this._prevOrientation = this.orientation;

                this.orientationListener.dispatch();
            }
        }
    }

    //
    // Static functions
    //
    static initialize(sizeConfig) {
        Screen._main = new Screen(sizeConfig);
        return Screen._main;
    }

    // If height is undefined, width is used as a ratio value
    static getOrientation(width,height) {
        return (height === undefined ? width >= 1 : width > height) ? "landscape" : "portrait";
    }
}